import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Container,
  Form,
  Table,
  Button,
  Modal,
  Row,
  Col,
} from "react-bootstrap";
import { apiGet, apiPut } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import { isEmpty } from "lodash";
import ReactPaginate from "react-paginate";
import { useForm } from "react-hook-form";
import "flatpickr/dist/themes/material_green.css";
import AuthContext from "../context/AuthContext";
import moment from "moment";
import obj from "../utils/helpers";
const ReferralReport = () => {
  let { user } = useContext(AuthContext);
  const [mark, setMark] = useState(false);
  const setMarkToggle = () => setMark(!mark);
  const [open, setOpen] = useState(false);
  const [model, setModel] = useState({
    type: "",
    id: "",
  });
  const setOpenToggle = () => {
    setOpen(!open);
    setModel({
      type: "",
      id: "",
    });
  };
  var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const { handleSubmit, reset } = useForm({});
  const [updateDate, setUpdateDate] = useState(false);
  const setUpdateDateToggle = () => setUpdateDate(!updateDate);
  const [isLoader, setLoader] = useState(false);
  const [matchData, setMatchData] = useState("");
  const [pageCount, setPageCount] = useState(0);
  const [viewpage, setViewPage] = useState(0);
  const [search_params, setSearchParams] = useState({
    page: 1,
    limit: 100,
    status: "active",
    gameType: "cricket",
    fromPeriod: previousDate,
    toPeriod: currentDate,
  });

  const getMatchData = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.referralReport,
      search_params
    );
    if (status === 200) {
      if (response_users.success) {
        setMatchData(response_users.results);
      }
    }
  };

  const handlePageClick = (event) => {
    setSearchParams((prevState) => {
      return {
        ...prevState,
        page: event.selected + 1,
      };
    });
    setViewPage(event.selected);
  };

  const handleSearch = (keyword) => {
    setSearchParams((prevState) => {
      return {
        ...prevState,
        page: 1,
        keyword: keyword,
      };
    });
  };

  useEffect(() => {
    setPageCount(matchData?.totalPages || []);
  }, [matchData]);

  useEffect(() => {
    getMatchData();
    setViewPage(search_params.page ? search_params.page - 1 : 0);
  }, [search_params]);

  return (
    <div>
      <section className="main-inner-outer py-4">
        <Container fluid>
          <div className="db-sec">
            <h2 className="common-heading">Referral Report</h2>
          </div>
          <div className="bet_status border-0 mb-0">
            <Row>
              <Col lg={2} sm={3} className="mb-lg-0 mb-1">
                <div className="bet-sec bet-period">
                  <Form.Label className="mt-2 me-2">From</Form.Label>
                  <Form.Group className="form-group">
                    <Form.Control
                      onChange={(e) =>
                        setSearchParams({
                          ...search_params,
                          fromPeriod: e.target.value,
                          filterByDay: "",
                        })
                      }
                      max={new Date().toISOString().split("T")[0]}
                      value={search_params.fromPeriod}
                      type="date"
                    />
                    <Form.Control
                      className="small_form_control"
                      type="text"
                      placeholder="00:00"
                      disabled
                    />
                  </Form.Group>
                </div>
              </Col>
              <Col
                lg={2}
                sm={3}
                className="mb-lg-0 mb-1"
                style={{ display: "flex" }}
              >
                <div className="bet-sec bet-period">
                  <Form.Label className="mt-2 me-2">To</Form.Label>
                  <Form.Group className="form-group">
                    <Form.Control
                      onChange={(e) =>
                        setSearchParams({
                          ...search_params,
                          toPeriod: e.target.value,
                          filterByDay: "",
                        })
                      }
                      min={
                        search_params?.fromPeriod
                          ? new Date(search_params?.fromPeriod)
                              .toISOString()
                              .split("T")[0]
                          : new Date()
                      }
                      disabled={search_params.fromPeriod ? false : true}
                      max={new Date().toISOString().split("T")[0]}
                      value={search_params.toPeriod}
                      type="date"
                    />
                    <Form.Control
                      className="small_form_control"
                      type="text"
                      placeholder="23:59"
                      disabled
                    />
                  </Form.Group>
                </div>
                <Button
                  className="theme_light_btn theme_dark_btn"
                  style={{ width: "40%" }}
                  onClick={() => getMatchData()}
                >
                  Get History
                </Button>
              </Col>
            </Row>
          </div>
          {!isEmpty(matchData) && (
            <section className="total-balance-sec">
              <Container fluid className="px-0">
                <ul className="list-unstyled">
                  <li>
                    <dt>Referral Amount</dt>
                    <strong>
                      {obj?.currencyFormat(matchData?.referralAmount)}
                    </strong>
                  </li>
                  <li>
                    <dt>Over Referral All Amount</dt>
                    <strong>
                      {obj?.currencyFormat(matchData?.overReferralAllAmount)}
                    </strong>
                  </li>
                </ul>
              </Container>
            </section>
          )}
          <div className="inner-wrapper">
            <div className="common-container">
              <div className="account-table batting-table">
                <div className="responsive">
                  <Table>
                    <thead>
                      <tr>
                        <th scope="col" style={{ width: `5%` }}>
                          Sr no.
                        </th>
                        <th scope="col" style={{ width: `10%` }}>
                          {" "}
                          Referred By
                        </th>
                        <th scope="col" style={{ width: `10%` }}>
                          Player Count
                        </th>
                        <th scope="col" style={{ width: `10%` }}>
                          Bonus Earned
                        </th>
                        <th scope="col" style={{ width: `65%` }}>
                          Referral Username
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {matchData &&
                        matchData?.referralSummary?.map((matchList, index) => {
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>

                              <td>{matchList.username}</td>
                              <td>{matchList.count || 0}</td>
                              <td>
                                {obj.currencyFormat(matchList.earnd) || 0}
                              </td>
                              <td>{matchList.referrals}</td>
                            </tr>
                          );
                        })}
                      {isEmpty(matchData?.referralSummary) ? (
                        <tr>
                          <td colSpan={5}>No records found</td>
                        </tr>
                      ) : null}
                    </tbody>
                  </Table>
                  <div className="bottom-pagination">
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel=" >"
                      forcePage={viewpage}
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={10}
                      pageCount={pageCount}
                      previousLabel="< "
                      renderOnZeroPageCount={null}
                      activeClassName="p-1"
                      activeLinkClassName="pagintion-li"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default ReferralReport;
